import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTermsAndConditionById,
  fetchTermsAndConditions,
  updateTermsAndCondition,
  updateStatusInTermsAndCondition,
  addTermsAndCondition,
  deleteTermsAndCondition,
  fetchTermsAndConditionByDropDown,
  fetchTermsAndConditionsOptions
} from "./thunk";

interface TermsAndConditionState {
  termsAndConditionsList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedTermsAndCondition: any;
  termsAndConditionsOptions: any[];
}

const initialState: TermsAndConditionState = {
  termsAndConditionsList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedTermsAndCondition: null,
  termsAndConditionsOptions: [],
};

const termsAndConditionSlice = createSlice({
  name: "TermsAndCondition",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTermsAndConditions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTermsAndConditions.fulfilled, (state, action) => {
        state.loading = false;
        state.termsAndConditionsList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchTermsAndConditions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Terms And Conditions";
      })
      .addCase(fetchTermsAndConditionById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTermsAndConditionById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedTermsAndCondition = action.payload;
      })
      .addCase(fetchTermsAndConditionById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateTermsAndCondition.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.termsAndConditionsList = state.termsAndConditionsList.map((term) =>
          term.id === action.payload.id || term.termsAndCondition_id === action.payload.id
            ? action.payload
            : term
        );
      })
      .addCase(updateTermsAndCondition.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update Terms And Condition";
      })
      .addCase(updateStatusInTermsAndCondition.fulfilled, (state, action) => {
        // Status update handled by refetching the list
      })
      .addCase(updateStatusInTermsAndCondition.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      })
      .addCase(addTermsAndCondition.fulfilled, (state, action) => {
        // New item will be added to list via refetch
      })
      .addCase(addTermsAndCondition.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to add Terms And Condition";
      })
      .addCase(deleteTermsAndCondition.fulfilled, (state, action) => {
        state.termsAndConditionsList = state.termsAndConditionsList.filter(
          (term) => term.id !== action.payload && term.termsAndCondition_id !== action.payload
        );
      })
      .addCase(deleteTermsAndCondition.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to delete Terms And Condition";
      })
      .addCase(fetchTermsAndConditionByDropDown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTermsAndConditionByDropDown.fulfilled, (state, action) => {
        state.loading = false;
        state.termsAndConditionsList = action.payload.data;
      })
      .addCase(fetchTermsAndConditionByDropDown.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchTermsAndConditionsOptions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTermsAndConditionsOptions.fulfilled, (state, action) => {
        state.loading = false;
        state.termsAndConditionsOptions = action.payload.data;
      })
      .addCase(fetchTermsAndConditionsOptions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default termsAndConditionSlice.reducer;
